import { observable, action, decorate } from 'mobx';
import Ajax from '../ajax/ajax';
import EventBus from '../helper/event.bus';
import { eventBusMessages, eventTypesForBus } from '../helper/enums';

export class ReportingStore {

    constructor(rootStore) {
        this.rootStore = rootStore;
    }

    allReports = [];

    renderSpinner = false;

    setRenderSpinner = (shouldRender) => this.renderSpinner = shouldRender;

    setAllReports = (reports) => this.allReports = reports;

    get getReports() { return this.allReports; }

    getAllReports = () => Ajax.generateReports(this.getAllReportsSuccess, this.getAllReportsError);

    getAllReportsSuccess = (response) => {
        this.setRenderSpinner(false);
        this.setAllReports(response.data);
    };

    getAllReportsError = (response) => {
        console.log(response);
        this.setRenderSpinner(false);
        EventBus.publish(eventTypesForBus.loadingReportError, eventBusMessages.loadingReportError);
    }

    inactiveUserAccsReports = [];

    setInactiveUserAccsReports = (reports) => this.inactiveUserAccsReports = reports;

    get getInactiveUserAccsReports() { return this.inactiveUserAccsReports; }

    getAllInactiveUserAccsReports = () => Ajax.generateInactiveAccsReports(this.getAllInactiveUserAccsReportsSuccess, this.getAllInactiveUserAccsReportsError);

    getGCPReport = () => Ajax.generateGCPReport(this.generateGCPReportSuccess, this.generateGCPReportError);

    getPeopleAccountsHavingPasswordNeverExpireReport = () => Ajax.generatePasswordNeverExpiresReport(this.generatePeopleAccountsHavingPasswordNeverExpireReportSuccess, this.generatePeopleAccountsHavingPasswordNeverExpireReportError);

    getPGsWithoutDescription = () => Ajax.generatePGsWithoutDescriptionReport(this.generatePGsWithoutDescriptionReportSuccess, this.generatePGsWithoutDescriptionReportError);

    getAllInactiveUserAccsReportsSuccess = (response) => {
        this.setRenderSpinner(false);
        this.setInactiveUserAccsReports(response.data);
    };

    getAllInactiveUserAccsReportsError = (response) => {
        console.log(response);
        this.setRenderSpinner(false);
        EventBus.publish(eventTypesForBus.loadingReportError, eventBusMessages.loadingReportError);
    }

    allUserAccs = [];

    setАllUserAccs = (reports) => this.allUserAccs = reports;

    get getAllUserAccs() { return this.allUserAccs; }

    getAllAccs = () => Ajax.generateAllUserAccsReports(this.getAllAccsSuccess, this.getAllAccsError);
    getAllAccsSuccess = (response) => {
        this.setRenderSpinner(false);
        this.setАllUserAccs(response.data);
    }
    getAllAccsError = (response) => {
        console.log(response);
        this.setRenderSpinner(false);
        EventBus.publish(eventTypesForBus.loadingReportError, eventBusMessages.loadingReportError);
    }

    userWithoutRoles = [];

    setUserWithoutRoles = (reports) => this.userWithoutRoles = reports;

    get getUserWithoutRoles() { return this.userWithoutRoles; }

    getActiveUserWithoutRoles = () => Ajax.generateUsersWithoutRolesReports(this.getAllAccsSuccess, this.getAllAccsError);
    getActiveUserWithoutRolesSuccess = (response) => {
        this.setRenderSpinner(false);
        this.setUserWithoutRoles(response.data);
    }
    getActiveUserWithoutRolesError = (response) => {
        console.log(response);
        this.setRenderSpinner(false);
        EventBus.publish(eventTypesForBus.loadingReportError, eventBusMessages.loadingReportError);
    }

    pgChanges = [];

    setPgChanges = (reports) => this.pgChanges = reports;

    get getPgChanges() { return this.pgChanges; }

    getPgChangesData = (totalLines) => Ajax.generatePgChangePerUserReports(totalLines, this.getPgChangesSuccess, this.getPgChangesError);
    getPgChangesSuccess = (response) => {
        this.setRenderSpinner(false);
        this.setPgChanges(response.data);
    }
    getPgChangesError = (response) => {
        console.log(response);
        this.setRenderSpinner(false);
        EventBus.publish(eventTypesForBus.loadingReportError, eventBusMessages.loadingReportError);
    }

    unmatchedEmployees = [];

    getUnmatchedEmployees = () => Ajax.generateUnmatchedEmployeesReports(this.getUnmatchedEmployeesSuccess, this.getUnmatchedEmployeesError);

    getUnmatchedEmployeesSuccess = (response) => {
        this.unmatchedEmployees = response.data;
        this.unmatchedEmployees.forEach(e => {
            e.accountName = e.account.name;
        });
        this.setRenderSpinner(false);
    }

    getUnmatchedEmployeesError = (error) => {
        this.setRenderSpinner(false);
        EventBus.publish(eventTypesForBus.loadingReportError, eventBusMessages.loadingReportError);
        console.log(error);
    }

    gcpAccounts = [];

    generateGCPReportSuccess = (response) => {
        this.gcpAccounts = response.data;
        this.gcpAccounts.forEach(a => {
            a.fullName = `${a.firstName ?? ""} ${a.secondName ?? ""} ${a.surname ?? ""}`;
            a.empTitle = a.work.title;
            a.status = a.internal.status;
        });
        this.setRenderSpinner(false);
    }

    generateGCPReportError = (error) => {
        this.setRenderSpinner(false);
        EventBus.publish(eventTypesForBus.loadingReportError, eventBusMessages.loadingReportError);
        console.log(error);
    }

    pgsWithoutDescription = [];

    generatePGsWithoutDescriptionReportSuccess = (response) => {
        this.pgsWithoutDescription = response.data;
        this.setRenderSpinner(false);
    }

    generatePGsWithoutDescriptionReportError = (error) => {
        this.setRenderSpinner(false);
        EventBus.publish(eventTypesForBus.loadingReportError, eventBusMessages.loadingReportError);
        console.log(error);
    }

    peopleAccountsHavingPasswordNeverExpire = [];

    generatePeopleAccountsHavingPasswordNeverExpireReportSuccess = (response) => {
        this.peopleAccountsHavingPasswordNeverExpire = response.data;
        this.peopleAccountsHavingPasswordNeverExpire.forEach(p => {
            p.accountName = p.account.name;
        });
        this.setRenderSpinner(false);
    }

    generatePeopleAccountsHavingPasswordNeverExpireReportError = (error) => {
        this.setRenderSpinner(false);
        EventBus.publish(eventTypesForBus.loadingReportError, eventBusMessages.loadingReportError);
        console.log(error);
    }

    qarFindings = [];

    getAllFindingsForAllAccounts = (complianceReviewId) => Ajax.getAllFindingsForAllAccounts(complianceReviewId, this.getAllFindingsForAllAccountsSuccess, this.getAllFindingsForAllAccountsError);

    getAllFindingsForAllAccountsSuccess = (response) => {
        this.setRenderSpinner(false);
        this.qarFindings = response.data;
    };

    getAllFindingsForAllAccountsError = (error) => {
        console.log(error);
    }
}

decorate(ReportingStore, {
    allReports: observable,
    setAllReports: action,
    setRenderSpinner: action,
    renderSpinner: observable,
    inactiveUserAccsReports: observable,
    setInactiveUserAccsReports: action,
    allUserAccs: observable,
    setАllUserAccs: action,
    pgChanges: observable,
    setPgChanges: action,
    gcpAccounts: observable,
    peopleAccountsHavingPasswordNeverExpire: observable,
    qarFindings: observable
})